import styled from 'styled-components';
import { Link } from 'gatsby';
import {
  headLine4,
  hoverEffect,
  hoverImageEffect,
  lineClamp,
  linkText,
  para2,
} from '../../theme/GlobalStyle';

export const CardContainer = styled.div`
  width: 100%;
  @media (max-width: 824px) {
    display: flex;
    flex-flow: column;
  }
`;
export const PostImage = styled(Link)`
  width: 100%;
  margin: 0;
  position: relative;
  cursor: pointer;
  display: block;
  ${hoverImageEffect()}
  figcaption {
    position: absolute;
    top: 6%;
    left: 6%;
    color: ${(props) => props.theme.color.white};
    ${linkText}
  }
  @media (max-width: 824px) {
    flex-basis: 25%;
    flex-shrink: 0;
    figcaption {
      display: none;
    }
  }
`;

export const PostContentData = styled.div`
  margin: 15px 0 0;
  @media (max-width: 824px) {
    padding: 0;
    background-color: transparent;
  }
  .content {
    margin: 5px 0 0;
    color: ${(props) => props.theme.color.textLight};
    ${para2}
  }
`;

export const PostHeading = styled.h4`
  color: ${(props) => props.theme.color.textLight};
  ${headLine4}
  ${lineClamp()}
  ${hoverEffect()}
`;
export const PostParaContent = styled.p`
  padding: 15px 0;
  ${linkText}
  color: ${(props) => props.theme.color.primary};
  @media (max-width: 824px) {
    display: none;
  }
`;

export const NewsItemBottom = styled.div`
  margin: 10px 0 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  ${linkText}
  color: ${(props) => props.theme.color.textLight};

  .divider {
    display: inline-block;
    width: 4px;
    height: 4px;
    border-radius: 100%;
    margin: 0 8px 0 6px;
    background-color: ${(props) => props.theme.color.textLight};
  }

  .author-container {
    margin: 0 5px 0 0;
  }
  .author-name {
    color: ${(props) => props.theme.color.primary};
    transition: text-decoration ease-in-out 0.2s;
  }

  @media (min-width: 1024px) {
    .author-name:hover {
      text-decoration: underline;
    }
  }
`;
